import validate from "validate.js";
import pick from "lodash.pick";
import { INPUT_NAMES } from "../utils/config";

const allowEmpty = false;

const constraints = {
	[INPUT_NAMES.email]: {
		email: {
			message: "validation.email",
		},
	},
	[INPUT_NAMES.firstName]: {
		presence: {
			allowEmpty,
			message: "validation.firstName",
		},
	},
	[INPUT_NAMES.lastName]: {
		presence: {
			allowEmpty,
			message: "validation.lastName",
		},
	},
	[INPUT_NAMES.name]: {
		presence: {
			allowEmpty,
			message: "validation.name",
		},
	},
	[INPUT_NAMES.phoneNumber]: {
		presence: {
			allowEmpty,
			message: "validation.phone",
		},
	},
	[INPUT_NAMES.company]: {
		presence: {
			allowEmpty,
			message: "validation.company",
		},
	},
	[INPUT_NAMES.recaptcha]: {
		presence: {
			allowEmpty,
			message: "validation.recaptcha",
		},
	},
};

// removing the parens creates an ambiguous arrow error
// eslint-disable-next-line no-extra-parens
export const isValid = errObj => (errObj ? false : null);

export default inputs => {
	const filteredConstraints = pick(constraints, Object.keys(inputs));
	return validate(inputs, filteredConstraints, { fullMessages: false });
};



// WEBPACK FOOTER //
// ./src/utils/validation.js